import Vue from 'vue'
import { deepEqual } from 'fast-equals'
// @ts-expect-error
if (!Vue.__analytics__) {
  // @ts-expect-error
  Vue.__analytics__ = true
  Vue.mixin({
    data: () => ({
      analyticsMixinLastEventName: null,
      analyticsMixinLastEventData: null,
      analyticsMixinExtraData: {},
    }),
    methods: {
      setExtraAnalyticsData(data: Record<string, any>) {
        this.$data.analyticsMixinExtraData = data
      },
      fireAnalyticsEvent(
        event: string,
        data: Record<string, any> = {},
        allowRepeat: boolean = true
      ) {
        if (!allowRepeat) {
          if (
            this.$data.analyticsMixinLastEventData !== null &&
            this.$data.analyticsMixinLastEventName !== null
          ) {
            const sameEvent =
              this.$data.analyticsMixinLastEventName === event &&
              deepEqual(this.$data.analyticsMixinLastEventData, data)
            if (sameEvent) return
          }
        }

        this.$data.analyticsMixinLastEventName = event
        this.$data.analyticsMixinLastEventData = JSON.parse(
          JSON.stringify(data)
        )

        this.$gtm.push({
          event,
          event_data: { ...this.$data.analyticsMixinExtraData, ...data },
        })
        this.$posthog.capture(event, {
          ...this.$data.analyticsMixinExtraData,
          ...data,
        })
      },
    },
  })
}
